import { Add } from '@mui/icons-material';
import { IconButton } from '../material';
import useGridApiContext from 'libs/mui/data-grid/hooks/useGripApiContext';
import { GridPreferencePanelsValue } from 'libs/mui/data-grid/enums/data-grid.enum';

const CXDataGridManageColumnsButton: React.FC = () => {
  const gridApi = useGridApiContext();

  const openManageColumns = () => {
    gridApi.showPreferences(GridPreferencePanelsValue.columns);
  };

  return (
    <IconButton size="small" onClick={openManageColumns}>
      <Add fontSize="small" />
    </IconButton>
  );
};

export default CXDataGridManageColumnsButton;
